import styled, { css, keyframes } from "styled-components"
import { colors } from "../../../../../../lib/colors"
import { tabletMediumText } from "../../../../../../media_queries/TabletMediaQueries"
import { coefficientColorCheck } from "../../../../../helpers/coefficientColor"
import { decideAnimation } from "../liveScoresComponentHelpers/liveScoresHelper"

interface live_score_each_props {
  winner: boolean
  i?: number
}

interface live_score_coef {
  number: number
}

export const LiveScoreColumnContainer = styled.div`
  margin: 22px 0 16px;
  height: 272px;
  overflow-y: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }
  @media only screen and (min-width: 1024px) {
    height: calc(100% - 40px);
  }
`
export const LiveScoreColumnHeader = styled.div`
  display: grid;
  grid-template-columns: 24% 22% 30% 26%;
  padding: 0 10px 6px;
  h1 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${colors.lightGrey};
    text-transform: uppercase;
    pointer-events: none;
  }
  @media only screen and (min-width: 768px) {
    h1 {
      font-size: 16px;
    }
  }
  @media only screen and (min-width: 1024px) {
    grid-template-columns: 24% 22% 30% 26%;
  }
`
export const LiveScoreEach = styled.div<live_score_each_props>`
  background-color: ${({ winner }) =>
    winner ? colors.liveScoreWinner : "rgba(28,30,36, 0.6)"};
  height: 26px;
  padding: 4px 10px;
  border-radius: 4px;
  margin-top: 4px;
  display: grid;
  grid-template-columns: 24% 22% 30% 26%;
  animation: ${({ i }) =>
    css`
      ${decideAnimation(i)} 0.5s forwards
    `};
  animation-delay: all 0.4s;
  position: relative;
  pointer-events: none;
  align-items: center;
  div {
    display: inline;
    position: relative;
    display: flex;
    align-items: center;
    /* top: -2px; */
  }
  @media only screen and (min-width: 768px) {
    grid-template-columns: 24% 22% 30% 26%;
  }
`
export const LiveScorePlayer = styled.h1`
  white-space: nowrap;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: ${colors.liveScoreText};
  ${tabletMediumText}
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
`
export const LiveScoreCash = styled.h1`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: ${colors.liveScoreText};
  text-overflow: ellipsis;
  overflow: hidden;
  ${tabletMediumText}
`
export const LiveScoreCoef = styled.div<live_score_coef>`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: ${({ number }) => (number === 0 ? colors.liveScoreText : "#ffffff")};
  text-align: start;
  gap: 10px;
  padding: ${({ number }) => (number === 0 ? "0" : "2px 6px")};
  /* height: 18px; */
  pointer-events: none;
  background: ${({ number }) =>
    number === 0 ? "" : coefficientColorCheck(number)};
  border-radius: 2px;
  text-overflow: ellipsis;
  overflow: hidden;
`
